import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/key-accesses`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getByEntities({commit}, payload: {
    userId?: number,
    userGroupId?: number,
    targetId: number,
    targetType: "keys"|"keyGroups"|"nonTransferables",
  }) {
    return axiosInstance.get(`${baseUrl}`, {params: payload})
      .then((data) => data.data);
  },
  updateById({commit}, payload: { id: number, data: any }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}`, payload.data)
      .then((data) => data.data);
  },
  deleteById({commit}, payload: { id: number }) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
